import { render, staticRenderFns } from "./ApplicationRoles.vue?vue&type=template&id=73f5c252&"
import script from "./ApplicationRoles.vue?vue&type=script&lang=ts&"
export * from "./ApplicationRoles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports